module.exports = __webpack_public_path__ + "static/media/perfil.37c9ae93.svg";